import NewsCardItem from './NewsCardItem'
import NewsCardItemLoading from './NewsCardItemLoading'

export default NewsCardItem
export { NewsCardItemLoading }
